import React from 'react';
import PrimaryContact from '../assets/images/PrimaryContact.svg';

export default () => {
  return <img src={PrimaryContact} alt="" />;
};